
// import { Accordion, AccordionTab } from 'primereact/accordion'
import { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Api } from '../../../../services/api';
import { PMTemplatePerformancePoint } from '../../../../services/Template/pm-template-performance-point';
import { ProgressBar } from 'primereact/progressbar';
import './PmPerformancePoints.css'
import { FaPlus, FaSyncAlt, FaTrash, FaArrowUp, FaArrowDown, FaHistory, FaCheck, FaTimes } from 'react-icons/fa';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { IoArrowBackSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { px } from 'framer-motion';
import DragPerformanceTable from './DragPerformanceTable';
import PerformanceHistoryModal from './PerformanceHistoryModal';
import { PERFORMANCE_ITEMS_BY_ROLE } from '../../../../services/performanceItems/performanceItems';

const getPerformanceItems = (roleName) => {
    const key = (roleName || '').toLowerCase().trim();
    // Try exact match, or fallback to project manager, or default
    return PERFORMANCE_ITEMS_BY_ROLE[key] || PERFORMANCE_ITEMS_BY_ROLE['DEFAULT'];
};


const getInitialPerformance = (roleName) => {
    return getPerformanceItems(roleName).map(item => ({
        category: item.category,
        standard: item.standard,
        deadline: item.deadline,
        value: "no"
    }));
};

const PmPerformancePoints = ({ userData }) => {
    const navigate = useNavigate();

    var isAdmin = localStorage.getItem('isAdmin');
    
    // Determine Role Name for Performance Items Logic
    let currentRoleName = localStorage.getItem('role_name') || 'Project Manager';
    if (userData) {
         // userData format: type-uid-rid-fname-lname-rolename
         const parts = userData.split('-');
         if (parts.length > 5) {
             currentRoleName = parts.slice(5).join('-');
         }
    }
    const currentPerformanceItems = getPerformanceItems(currentRoleName);
    const TOTAL_ITEMS = currentPerformanceItems.length || 10;

    const [billableTime, setBillableTime] = useState([]);
    const [annualDeliverables, setAnnualDeliverables] = useState({ "revenue": { "q1": 0, "q2": 0, "q3": 0, "q4": 0, "total": 0 }, "actuals": { "q1": 0, "q2": 0, "q3": 0, "q4": 0, "total": 0 }, "variance": { "q1": 0, "q2": 0, "q3": 0, "q4": 0, "total": 0 } });
    const [perBonusMeasurablesReview, setPerBonusMeasurablesReview] = useState(getInitialPerformance(currentRoleName));
    const [goalForTheWeek, setGoalForTheWeek] = useState(PMTemplatePerformancePoint.getFormName().goalForTheWeek);
    const [toDiscuss, setToDiscuss] = useState(PMTemplatePerformancePoint.getFormName().toDiscuss);
    const [discussionItem, setDiscussionItem] = useState(PMTemplatePerformancePoint.getFormName().discussionItem);
    const [projectionAndAcutal, setProjectionAndAcutal] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [roleNameTitle, setRoleNameTitle] = useState(currentRoleName.toUpperCase());
    
    // Performance Checklist State
    const [checklistValues, setChecklistValues] = useState(() => {
        const initial = {};
        for(let i=0; i<TOTAL_ITEMS; i++) initial[i] = 'no';
        return initial;
    });


    const yesCount = Object.values(checklistValues).filter(v => v === 'yes').length;
    const noCount = Object.values(checklistValues).filter(v => v === 'no').length;
    
    // Check if Priority items (Row 1 or 2) are failed
    const isPriorityFail = checklistValues[0] === 'no' || checklistValues[1] === 'no';
    const weeklyScore = isPriorityFail ? 0 : (yesCount / TOTAL_ITEMS) * 100;



    const [isLoading, setIsLoading] = useState(true);

    // --------------------------------------------------------------------
    const [dateInput1, setDateInput1] = useState("");
    const [dateInput2, setDateInput2] = useState("");
    const [dateInput3, setDateInput3] = useState("");
    const [dateInput4, setDateInput4] = useState("");

    const [dataForPer, setDataForPer] = useState(115);
    const [totalPointMeetingJob, setTotalPointMeetingJob] = useState("");
    const [pointsMeetingJob, setPointsMeetingJob] = useState("");

    const [userName, setUserName] = useState("");
    const toast = useRef(null);

    const [roleID, setroleID] = useState('');

    // History Modal State
    const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);

    const handleOpenHistory = () => {
        setIsHistoryModalOpen(true);
    };

    const formik = useFormik({
        initialValues: {
            ...PMTemplatePerformancePoint.getFormName(),
            performance: getInitialPerformance(currentRoleName),
            is_away: false,
            away_reason: ''
        },
        validate: (data) => {

        },

        onSubmit: (data) => {

            const token = localStorage.getItem('authToken');
           
            if(data.from_date==null){
                const today = new Date();
        
                data.from_date = today; 
            }
          
            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            data.reviewPoint = dataForPer;
            data.total_points_meeting_job = totalPointMeetingJob;
            data.points_meeting_job = pointsMeetingJob;
            // data.user_id = localStorage.getItem('user_id');
            // data.role_id = localStorage.getItem('role_id');

            // Convert is_away to Y/N for backend
            if (typeof data.is_away === 'boolean') {
                data.is_away = data.is_away ? 'Y' : 'N';
            }


            // Enrich performance items with metadata for archiving
            if (data.performance && Array.isArray(data.performance)) {
                const currentUserId = data.user_id || localStorage.getItem('user_id');
                const timestamp = new Date().toISOString();
                
                data.performance = data.performance.map(item => {
                     // Destructure to exclude legacy fields
                     const {
                        clientEmailWeek, clientPlayBook, performanceBonusMeasReview,
                        vpCOComments, vpPoints_1, vpPoints_2, pmComments, oldId,
                        ...cleanItem
                    } = item;

                    return {
                        ...cleanItem,
                        // Ensure value is preserved or migrated
                        value: cleanItem.value || clientPlayBook || '',
                        
                        // Metadata
                        pm_id: currentUserId,
                        role_id: data.role_id || localStorage.getItem('role_id'),
                        // type: 'projectManager', // Explicitly set type as requested
                        active: 'Y',
                        from_date: monday,
                        to_date: sunday,
                        created_by: cleanItem.created_by || currentUserId,
                        created_at: cleanItem.created_at || timestamp,
                        updated_by: currentUserId,
                        updated_at: timestamp
                    };
                });
            }

            var url = Api.API_BASE_URL + 'performance-huddle/performance-points-save';


            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        
                        // Refresh data to show updates immediately
                        const currentUserId = data.user_id || localStorage.getItem('user_id');
                        const currentRoleId = data.role_id || localStorage.getItem('role_id');
                        // Use the type from formik or default to projectManager
                        const currentType = data.type || 'projectManager';
                        
                        performancePoints(currentUserId, currentRoleId, currentType);
                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });


        }
    });

    const handleChecklistChange = (index, value) => {
        setChecklistValues(prev => {
            // Enforce that one must be selected (radiogroup behavior)
            // If clicking the same value, keep it. If clicking different, switch.
            const newValue = value; 
            
            // Sync to Formik
            const updatedPerformance = [...(formik.values.performance || [])];
            // Ensure size
            while (updatedPerformance.length <= index) {
                updatedPerformance.push({
                   category: '', standard: '', deadline: '', value: ''
                }); 
            }
            // Update
            updatedPerformance[index] = {
                ...updatedPerformance[index],
                category: updatedPerformance[index].category || currentPerformanceItems[index]?.category || '',
                standard: updatedPerformance[index].standard || currentPerformanceItems[index]?.standard || '',
                deadline: updatedPerformance[index].deadline || currentPerformanceItems[index]?.deadline || '',
                value: newValue || "" 
            };
            formik.setFieldValue('performance', updatedPerformance);

            return {
                ...prev,
                [index]: newValue
            };
        });
    };

    const handleAwayChange = (e) => {
        const isChecked = e.checked;

        if (isChecked) {
            confirmDialog({
                message: (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ padding: '10px 20px' }}>
                            <p style={{ margin: '0 0 1.5rem 0', fontSize: '1.2rem', lineHeight: '1.6' }}>
                                Are you sure you want to mark the Project Manager as <strong>Away</strong>?
                            </p>
                            <div style={{ 
                                backgroundColor: '#fff3cd', 
                                color: '#856404', 
                                padding: '1.5rem', 
                                borderRadius: '8px', 
                                border: '1px solid #ffeeba', 
                                display: 'flex', 
                                alignItems: 'start',
                                marginBottom: '10px' 
                            }}>
                                <i className="pi pi-exclamation-triangle" style={{ fontSize: '1.8rem', marginRight: '15px', marginTop: '2px' }}></i>
                                <div style={{ lineHeight: '1.5', fontSize: '1rem' }}>
                                    <strong>Warning:</strong> This action will automatically set all performance points to <strong>NO</strong>.
                                </div>
                            </div>
                        </div>
                        {/* Explicit Spacer for separation from footer */}
                        <div style={{ height: '30px' }}></div>
                    </div>
                ),
                header: 'Confirm Away Status',
                icon: 'pi pi-question-circle',
                acceptClassName: 'p-button-danger',
                acceptLabel: 'Yes, Mark as Away',
                rejectLabel: 'Cancel',
                style: { width: '600px', maxWidth: '90vw' },
                accept: () => {
                    formik.setFieldValue('is_away', true);
                    
                    const newChecklistValues = {};
                    const updatedPerformance = formik.values.performance.map((item, index) => {
                         newChecklistValues[index] = 'no';
                         return { ...item, value: 'no' };
                    });
                    
                    // Ensure we define all keys if performance array is short
                    for(let i=0; i<TOTAL_ITEMS; i++) {
                         if (!newChecklistValues.hasOwnProperty(i)) newChecklistValues[i] = 'no';
                    }

                    setChecklistValues(newChecklistValues);
                    formik.setFieldValue('performance', updatedPerformance);
                },
                reject: () => {
                    // Do nothing
                }
            });
        } else {
            formik.setFieldValue('is_away', false);
        }
    };

    // TODO ------------------------ 

    const handleAddInputForMonthlyClientRating = () => {
        var s = {
            category: "",
            standard: "",
            deadline: "",
            value: ""
        };
        setPerBonusMeasurablesReview([...perBonusMeasurablesReview, s]);
        formik.values.performance.push(s);
    };

    const handleDeleteInputForMonthlyClientRating = (index) => {
        formik.values.performance.splice(index, 1);
        setPerBonusMeasurablesReview([...perBonusMeasurablesReview, PMTemplatePerformancePoint.getFormName().performance[0]]);
        var newArray = [...perBonusMeasurablesReview];
        newArray.splice(index, 1);
        setPerBonusMeasurablesReview(newArray);
    };


    // Discussion Item Handlers
    const handleAddInputFordiscussionItem = () => {
        const newItem = { discussion_items: '' };
        const newArray = [...discussionItem, newItem];
        setDiscussionItem(newArray);
        formik.setFieldValue('discussionItem', newArray);
    };

    const handleDeleteInputFordiscussionItem = (index) => {
        const newArray = [...discussionItem];
        newArray.splice(index, 1);
        setDiscussionItem(newArray);
        formik.setFieldValue('discussionItem', newArray);
    };

    const handleMoveUpDiscussionItem = (index) => {
        if (index === 0) return;
        const newArray = [...discussionItem];
        [newArray[index - 1], newArray[index]] = [newArray[index], newArray[index - 1]];
        setDiscussionItem(newArray);
        formik.setFieldValue('discussionItem', newArray);
    };

    const handleMoveDownDiscussionItem = (index) => {
        if (index === discussionItem.length - 1) return;
        const newArray = [...discussionItem];
        [newArray[index + 1], newArray[index]] = [newArray[index], newArray[index + 1]];
        setDiscussionItem(newArray);
        formik.setFieldValue('discussionItem', newArray);
    };

    // Goal For The Week Handlers
    const handleAddInputForGoalForTheWeek = () => {
        const newItem = {
            title: '',
            status: 'Y',
            status_2: 'Y',
            description: '',
            description_2: '',
        };
        const newArray = [...goalForTheWeek, newItem];
        setGoalForTheWeek(newArray);
        formik.setFieldValue('goalForTheWeek', newArray);
    };

    const handleDeleteInputForGoalForTheWeek = (index) => {
        const newArray = [...goalForTheWeek];
        newArray.splice(index, 1);
        setGoalForTheWeek(newArray);
        formik.setFieldValue('goalForTheWeek', newArray);
    };

    const handleMoveUpGoal = (index) => {
        if (index === 0) return;
        const newArray = [...goalForTheWeek];
        [newArray[index - 1], newArray[index]] = [newArray[index], newArray[index - 1]];
        setGoalForTheWeek(newArray);
        formik.setFieldValue('goalForTheWeek', newArray);
    };

    const handleMoveDownGoal = (index) => {
        if (index === goalForTheWeek.length - 1) return;
        const newArray = [...goalForTheWeek];
        [newArray[index + 1], newArray[index]] = [newArray[index], newArray[index + 1]];
        setGoalForTheWeek(newArray);
        formik.setFieldValue('goalForTheWeek', newArray);
    };

    // To Discuss Handlers
    const handleAddInputFortoDiscuss = () => {
        // Use a default object, similar to how other adds work or fallback
        const newItem = (PMTemplatePerformancePoint.getFormName() && PMTemplatePerformancePoint.getFormName().toDiscuss && PMTemplatePerformancePoint.getFormName().toDiscuss[0]) 
                        ? PMTemplatePerformancePoint.getFormName().toDiscuss[0] 
                        : { to_discuss: '' };
        
        const newArray = [...toDiscuss, newItem];
        setToDiscuss(newArray);
        formik.setFieldValue('toDiscuss', newArray);
    };

    const handleDeleteInputFortoDiscuss = (index) => {
        const newArray = [...toDiscuss];
        newArray.splice(index, 1);
        setToDiscuss(newArray);
        formik.setFieldValue('toDiscuss', newArray);
    };

    const handleMoveUpToDiscuss = (index) => {
        if (index === 0) return;
        const newArray = [...toDiscuss];
        [newArray[index - 1], newArray[index]] = [newArray[index], newArray[index - 1]];
        setToDiscuss(newArray);
        formik.setFieldValue('toDiscuss', newArray);
    };

    const handleMoveDownToDiscuss = (index) => {
        if (index === toDiscuss.length - 1) return;
        const newArray = [...toDiscuss];
        [newArray[index + 1], newArray[index]] = [newArray[index], newArray[index + 1]];
        setToDiscuss(newArray);
        formik.setFieldValue('toDiscuss', newArray);
    };

    // Performance Handlers
    const handlePerformanceReorder = (sourceIndex, destinationIndex) => {
        const newPerformance = [...(formik.values.performance || [])];
        
        // Remove from source
        const [movedItem] = newPerformance.splice(sourceIndex, 1);
        // Insert at destination
        newPerformance.splice(destinationIndex, 0, movedItem);
        
        formik.setFieldValue('performance', newPerformance);

        // Update checklist values state
        setChecklistValues(prev => {
             // Convert object to array for easier manipulation
             const valuesArray = [];
             // Assume keys 0 to length-1 are present
             for(let i=0; i<newPerformance.length; i++) {
                 // Use mapped value or default to 'no'
                 // Note: we are building the array from the OLD keys/values to start
                 // We don't know the exact length of 'prev', but we know 'newPerformance' length.
                 // Actually, we should iterate based on current performance length BEFORE the splice.
                 // But wait, 'prev' maps index -> status.
                 // If we had [0:'yes', 1:'no', 2:'yes'] and we move 0 to 2.
                 // Result should be [0:'no', 1:'yes', 2:'yes'] (indices shift).
                 
                 // So we need to construct an array from 'prev' first.
                 valuesArray.push(prev[i] || 'no'); 
             }
             
             // Apply same splice operation
             const [movedValue] = valuesArray.splice(sourceIndex, 1);
             valuesArray.splice(destinationIndex, 0, movedValue);
             
             // Convert back to object
             const newObj = {};
             valuesArray.forEach((v, i) => {
                 newObj[i] = v;
             });
             return newObj;
        });
    };




    //! -----------------------
    const headerStyle = {
        background: "#dddddd",
        border: "1px solid #E9ECEF",
        textAlign: "center",
        // padding: "4px 8px",
        height: "24px",
        lineHeight: "1.2",
        fontWeight: 700,
    };

    const cellStyle = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "center",
        border: '1px solid white',
    
    };

    const cellStyleH = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "center",
        border: '1px solid white',
        // height: '50px',
        padding: "4px 8px",
        height: "24px",
        lineHeight: "1.2"     
    };

    const sectionContainerStyle = {
        marginBottom: '25px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        overflow: 'hidden',
        border: '1px solid #eaedf0'
    };

    const sectionHeaderStyle = {
        backgroundColor: '#f8f9fa',
        padding: '15px 25px',
        borderBottom: '1px solid #eaedf0',
        fontWeight: '700',
        fontSize: '16px',
        color: '#2c3e50',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    };

    const sectionContentStyle = {
        padding: '0'
    };

    const cellStylea = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "start",
        padding: "5px",
        border: '1px solid white',
        padding: "4px 8px",
        height: "24px",
        lineHeight: "1.2"
    };

    const cellStylee = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        textAlign: 'end',

        padding: "4px 8px",
        height: "24px",
        lineHeight: "1.2"        
    };

    const cellStyleW = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: 'white',
        // paddingTop: '5px',
        padding: "4px 8px",
        height: "24px",
        lineHeight: "1.2"
    };

    const cellStyleD = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: '#9999',

        padding: "4px 8px",
        height: "24px",
        lineHeight: "1.2"
    };

    const yesCellStyle = {
        ...cellStyle,
    };

    const dropdownCellStyle = {
        ...yesCellStyle,
        padding: "0",
    };

    //! ----------------------------------------------------------

    useEffect(() => {
        var roleID = localStorage.getItem('role_id');
        setroleID(roleID)
        
        var name = localStorage.getItem('name');
        setUserName(name);

        if (userData == undefined) {
             setRoleNameTitle((localStorage.getItem('role_name') || "PROJECT MANAGER").toUpperCase());
            var user_id = localStorage.getItem('user_id');
            var role_id = localStorage.getItem('role_id');
            var type = 'projectManager';
            performancePoints(user_id, role_id, type);
        } else {
            const parts = userData.split('-');
            const parsedType = parts[0];
            const parsedUId = parts[1];
            const parsedRId = parts[2];
            const first_name = parts[3];
            const last_name = parts[4];
            
            // Extract role name if present (it's the 6th part, but keep in mind split)
            // format: type-uid-rid-fname-lname-rolename
            if (parts.length > 5) {
                // Join the rest back in case role name has hyphens
                const extractedRoleName = parts.slice(5).join('-');
                setRoleNameTitle((extractedRoleName || "PROJECT MANAGER").toUpperCase());
            }

            setUserName(first_name + ' ' + last_name);
            performancePoints(parsedUId, parsedRId, parsedType);
        }
        // performancePoints();
        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, []);



    const performancePoints = (user_id, role_id, type) => {
        // Reuse the same week-range logic as the save flow so load & save always agree:
        // - Monday only → previous week
        // - Tuesday only if Monday was a Canadian stat holiday → previous week
        // - All other days (Tue–Sun, when Mon wasn't a holiday) → current week
        const { monday: targetMonday, sunday: targetSunday } = getWeekRange();

        console.log(`Step 1: Fetching Performance Points for CURRENT WEEK: ${targetMonday} to ${targetSunday}`);

        const token = localStorage.getItem('authToken');
        formik.setFieldValue(`role_id`, role_id);
        formik.setFieldValue(`user_id`, user_id);
        
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        var _body = {
            userId: user_id,
            role_id: role_id,
            type: type,
            from_date: targetMonday,
            to_date: targetSunday,
        }
        
        fetch(Api.API_BASE_URL + 'performance-huddle/performance-points', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {
                setIsLoading(false);
                
               // formik.setFieldValue('from_date', new Date());
                //* -------------------------
                formik.setFieldValue('q1', response.projectionAndAcutal[0].ltTeam);
                formik.setFieldValue('q2', response.projectionAndAcutal[1].ltTeam);
                formik.setFieldValue('q3', response.projectionAndAcutal[2].ltTeam);
                formik.setFieldValue('q4', response.projectionAndAcutal[3].ltTeam);

                formik.setFieldValue('vpCommentsq1', response.projectionAndAcutal[0].vpComments);
                formik.setFieldValue('vpCommentsq2', response.projectionAndAcutal[1].vpComments);
                formik.setFieldValue('vpCommentsq3', response.projectionAndAcutal[2].vpComments);
                formik.setFieldValue('vpCommentsq4', response.projectionAndAcutal[3].vpComments);

                formik.setFieldValue('coreValuesq1', response.projectionAndAcutal[0].coreValues);
                formik.setFieldValue('coreValuesq2', response.projectionAndAcutal[1].coreValues);
                formik.setFieldValue('coreValuesq3', response.projectionAndAcutal[2].coreValues);
                formik.setFieldValue('coreValuesq4', response.projectionAndAcutal[3].coreValues);
                //! -------------------------


                setProjectionAndAcutal(response.projectionAndAcutal);
                if (response.billableTime) {
                    setBillableTime(response.billableTime);
                }

                if (response.annualDeliverables) {
                    setAnnualDeliverables(response.annualDeliverables);
                }

                setDataForPer(response.reviewPoint);
                setTotalPointMeetingJob(response.total_points_meeting_job);
                setPointsMeetingJob(response.points_meeting_job);

                if (response.projectPerfomance) {



                    formik.setFieldValue('projectPerfomanceID', response.projectPerfomance.id);
                    formik.setFieldValue('checkInHowAreYouDoing', response.projectPerfomance.checkInHowAreYouDoing);
                    formik.setFieldValue('whatCanIdoTosupporty', response.projectPerfomance.whatCanIdoTosupporty);
                    formik.setFieldValue('vpComOpsq1', response.projectPerfomance.vpComOpsq1);
                    formik.setFieldValue('vpComOpsq2', response.projectPerfomance.vpComOpsq2);
                    formik.setFieldValue('vpComOpsq3', response.projectPerfomance.vpComOpsq3);
                    formik.setFieldValue('vpComOpsq4', response.projectPerfomance.vpComOpsq4);
                    
                    // Populate Away status
                    let isAway = false;
                    let awayReason = '';

                    // Check performance items if parent status is false, as items might have the updated status
                    if (response.performance && Array.isArray(response.performance)) {
                        const awayItem = response.performance.find(item => item.is_away === 'Y');
                        if (awayItem) {
                            isAway = true;
                            awayReason = awayItem.away_reason || '';
                        }
                    }

                    formik.setFieldValue('is_away', isAway);
                    formik.setFieldValue('away_reason', awayReason);
                   
                    if (response.projectPerfomance.from_date != '0000-00-00') {

                        let timestamp = new Date(response.projectPerfomance.from_date);


                        formik.setFieldValue('from_date', response.projectPerfomance.from_date);

                        if (!isNaN(timestamp.getTime())) {
                            handleDateInputChange("dateInput1", timestamp.toISOString().split('T')[0])

                        }

                    }
                    // if (response.projectPerfomance.from_date != '0000-00-00') {
                    //     formik.setFieldValue('from_date', response.projectPerfomance.from_date);
                    //     handleDateInputChange("dateInput1", response.projectPerfomance.from_date)
                    // }
                    if (response.projectPerfomance.date != '0000-00-00') {
                        formik.setFieldValue('date', response.projectPerfomance.date);
                    }
                }

                if (response.goalForTheWeek.length > 0) {
                    setGoalForTheWeek(response.goalForTheWeek);
                    formik.setFieldValue(`goalForTheWeek`, response.goalForTheWeek);
                }
                if (response.toDiscuss.length != 0) {
                    setToDiscuss(response.toDiscuss);
                    formik.setFieldValue(`toDiscuss`, response.toDiscuss);
                }
                if (response.discussionItem.length > 0) {
                    setDiscussionItem(response.discussionItem);
                    formik.setFieldValue(`discussionItem`, response.discussionItem);
                }

                // Helper to process performance items
                const processPerformanceList = (list, isFromPreviousWeek = false) => {
                    let normalizedPerformance = [...list];
                    
                    if (normalizedPerformance.length > TOTAL_ITEMS) {
                        normalizedPerformance = normalizedPerformance.slice(0, TOTAL_ITEMS);
                    }
                    while (normalizedPerformance.length < TOTAL_ITEMS) {
                         normalizedPerformance.push({
                            category: '', standard: '', deadline: '', value: ''
                         });
                    }
                    
                    // Update Item Labels to match current definitions and schema
                    normalizedPerformance = normalizedPerformance.map((item, index) => {
                         const { 
                             clientEmailWeek, clientPlayBook, performanceBonusMeasReview, 
                             vpCOComments, vpPoints_1, vpPoints_2, pmComments, oldId,
                             ...rest 
                         } = item;
                         
                         // If from previous week, force reset value to 'no' (new week start)
                         // Otherwise use existing value or legacy field
                         let val = item.value || item.clientPlayBook || 'no';
                         if (isFromPreviousWeek) val = 'no';

                         // If from previous week, we also want to inherit the category/standard/deadline 
                         // from the PREVIOUS item, not necessarily overwrite with CONSTANTS if they differ.
                         // But the existing logic below falls back to PERFORMANCE_ITEMS if keys are missing.
                         
                         return {
                             ...rest, 
                             category: item.category || currentPerformanceItems[index]?.category || '',
                             standard: item.standard || currentPerformanceItems[index]?.standard || '',
                             deadline: item.deadline || currentPerformanceItems[index]?.deadline || '',
                             value: val,
                             // If from previous week, clear ID to create new record
                             ...(isFromPreviousWeek ? { id: undefined, performance_id: undefined } : {})
                         };
                    });

                    setPerBonusMeasurablesReview(normalizedPerformance);
                    formik.setFieldValue(`performance`, normalizedPerformance);

                    const loadedChecklist = {};
                    normalizedPerformance.forEach((item, index) => {
                         if (index < TOTAL_ITEMS) {
                             loadedChecklist[index] = (item.value === 'yes') ? 'yes' : 'no';
                         }
                    });
                    setChecklistValues(loadedChecklist);
                };

                // Check if we have SAVED data (meaning checking for ID existence)
                // We check for both 'projectPerfomance' (legacy typo) and 'projectPerformance' (potential fix)
                
                const parentRecord = response.projectPerfomance || response.projectPerformance;
                // Check if ID exists (handling various ID formats: id, _id, performance_id)
                // Also ensuring we don't treat default "0" or empty string as a valid ID
                const isValidId = (id) => id !== undefined && id !== null && id !== 0 && id !== '0' && id !== "";
                
                const hasParentRecord = parentRecord && (isValidId(parentRecord.id) || isValidId(parentRecord._id) || isValidId(parentRecord.performance_id)); 
                
                // Check performance items for IDs
                const hasPerformanceItems = response.performance && response.performance.length > 0 && response.performance.some(item => isValidId(item.id) || isValidId(item.performance_id) || isValidId(item._id));

                // Also check if other significant sections have saved data (IDs), which implies the report for this week exists
                const hasGoals = response.goalForTheWeek && response.goalForTheWeek.some(item => isValidId(item.id) || isValidId(item._id));
                const hasDiscussion = response.discussionItem && response.discussionItem.some(item => isValidId(item.id) || isValidId(item._id));

                // If ANY part of the form has saved data (IDs), we consider the Current Week Report to "Exist" 
                // and we will NOT auto-load the previous week's template.
                const hasSavedPerformanceData = hasParentRecord && hasPerformanceItems;
                
                console.log(`Step 2: Analysis - Has Saved Data for ${targetMonday}?`, { 
                    result: hasSavedPerformanceData,
                    hasParentRecord, 
                    hasPerformanceItems,
                    hasGoals,
                    hasDiscussion,
                    parentId: parentRecord?.id
                });
                
                if (hasSavedPerformanceData) {
                    console.log("Loading Current Week Saved Data");
                    processPerformanceList(response.performance || [], false);
                } else if (response.previousWeekData && response.previousWeekData.length > 0 && !hasPerformanceItems) {
                    // Start fresh for current week, but carry over items structure from previous week
                    formik.setFieldValue('from_date', targetMonday);
                    
                    console.log("Using prior week performance as template");
                    if (toast.current) {
                        toast.current.show({ severity: 'info', summary: 'Template Loaded', detail: 'Performance items carried over from previous week.' });
                    }
                    processPerformanceList(response.previousWeekData, true);
                } else {
                    // Set date to current week explicitly since we are starting fresh
                    formik.setFieldValue('from_date', targetMonday);
                    
                    console.log("Using default performance template (No previous week data)");
                    // If the current week response actually had (unsaved) items, use them instead of hardcoded defaults
                    // so we don't lose any default standards formatting from backend if it differs
                    if (response.performance && response.performance.length > 0) {
                       processPerformanceList(response.performance, false);
                    } else {
                       const initial = getInitialPerformance(currentRoleName);
                       processPerformanceList(initial, false);
                    }
                }
            
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });

    }

    // Function to get Monday and Sunday of the current week
    const getWeekRange = () => {
        const today = new Date();
        const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)

        // Helper: Check if a given date is a Canadian Statutory Holiday
        const isCanadianStatHoliday = (d) => {
            const date = d.getDate();
            const month = d.getMonth() + 1; // 1-12
            const year = d.getFullYear();
            
            // 1. Fixed Date Holidays
            // New Year's (Jan 1), Canada Day (July 1), Truth & Reconciliation (Sept 30), 
            // Remembrance Day (Nov 11), Christmas (Dec 25), Boxing Day (Dec 26)
            if (
                (month === 1 && date === 1) ||
                (month === 7 && date === 1) ||
                (month === 9 && date === 30) ||
                (month === 11 && date === 11) ||
                (month === 12 && date === 25) ||
                (month === 12 && date === 26)
            ) {
                return true;
            }

            // 2. Floating Monday Holidays
            const isMonday = d.getDay() === 1;
            if (!isMonday) return false;

            // Family Day: 3rd Monday in Feb
            if (month === 2) {
                // It's the 3rd Monday if date is between 15 and 21
                if (date >= 15 && date <= 21) return true;
            }

            // Victoria Day: Monday before May 25 (last Monday on or before May 24)
            if (month === 5) {
                if (date >= 18 && date <= 24) return true;
            }

            // Civic Holiday: 1st Monday in Aug
            if (month === 8) {
                if (date <= 7) return true;
            }

            // Labour Day: 1st Monday in Sept
            if (month === 9) {
                if (date <= 7) return true;
            }

            // Thanksgiving: 2nd Monday in Oct
            if (month === 10) {
                 if (date >= 8 && date <= 14) return true;
            }

            // 3. Good Friday / Easter Monday (Hardcoded for 2024-2030 to avoid complex calculation)
            // Good Friday Dates: 2024-03-29, 2025-04-18, 2026-04-03, 2027-03-26, 2028-04-14, 2029-03-30, 2030-04-19
            // Easter Monday Dates: 2024-04-01, 2025-04-21, 2026-04-06, 2027-03-29, 2028-04-17, 2029-04-02, 2030-04-22
            const easterMondays = [
                "2024-04-01", "2025-04-21", "2026-04-06", "2027-03-29", 
                "2028-04-17", "2029-04-02", "2030-04-22"
            ];
            const dateStr = `${year}-${String(month).padStart(2,'0')}-${String(date).padStart(2,'0')}`;
            if (easterMondays.includes(dateStr)) return true;

            // Optional: Good Friday check if asking about "Monday IS a holiday" meaning Easter Monday? 
            // Or if Friday was holiday, Monday is off? 
            // Usually "Stat Holiday on Monday" implies the day off is Monday.
            
            return false;
        };

        // Calculate Monday based on standard week
        const monday = new Date(today);
        monday.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

        let showPreviousWeek = false;
        let holidayInfo = null;

        // 1. If today is Monday, always show previous week.
        if (dayOfWeek === 1) {
            showPreviousWeek = true;
            // Check if TODAY is a holiday
            if (isCanadianStatHoliday(today)) {
                holidayInfo = "Today is a Stat Holiday";
            }
        } 
        // 2. If today is Tuesday, check if YESTERDAY (Monday) was a holiday.
        else if (dayOfWeek === 2) {
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            
            if (isCanadianStatHoliday(yesterday)) {
                 showPreviousWeek = true;
                 holidayInfo = "Yesterday was a Holiday";
            }
        }

        if (showPreviousWeek) {
            monday.setDate(monday.getDate() - 7);
        }

        // Calculate Sunday (Add days to current day to get to Sunday)
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);

        const formatDate = (date) => {
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        };

        return {
            monday: formatDate(monday),
            sunday: formatDate(sunday),
            holidayInfo
        };
    };

    const { monday, sunday, holidayInfo } = getWeekRange();

    // const handleDateInputChange = (inputId, selectedDate) => {
    //     // Update the state of the selected input
    //     switch (inputId) {
    //         case "dateInput1":
    //             setDateInput1(selectedDate);
    //             setDateInput2(addDays(selectedDate, 6));
    //             setDateInput3(addDays(selectedDate, 7)); // Adjusted to 7 days
    //             setDateInput4(addDays(selectedDate, 13)); // Adjusted to 13 days
    //             break;
    //         default:
    //             break;
    //     }
    // };

    const handleDateInputChange = (inputId, selectedDate) => {
        formik.setFieldValue('from_date', monday);

        // Update the state of the selected input
        switch (inputId) {
            case "dateInput1":
                setDateInput1(monday);
                setDateInput2(addDays(monday, 6));
                setDateInput3(addDays(monday, 7)); // Adjusted to 7 days
                setDateInput4(addDays(monday, 13)); // Adjusted to 13 days
                break;
            default:
                break;
        }
    };    

    const addDays = (dateString, days) => {
        const date = new Date(dateString);
        date.setDate(date.getDate() + days);
        return date.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
    };

    const priceBodyTemplatee = (rowData) => {
        if (rowData === '') {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {

            return '';
        }

        const isNegative = rowData < 0; // Check if the value is negative

        return (
            <span style={{ color: isNegative ? "red" : "black" }}>
                {formatCurrency(rowData)}
                {/* $ {numberValue.toFixed(2) } */}
            </span>
        );
    };


    const priceBodyTemplateeYearly = (rowData) => {
        if (rowData === '') {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {

            return '';
        }

        const isNegative = rowData < 0; // Check if the value is negative

        return (
            <span style={{ color: isNegative ? "red" : "black", }}>
                {formatCurrency(rowData)}
            </span>
        );
    };

    const formatCurrency = (value) => {
        if (value == null) {
            return ''
        }
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
    // --------------------------------------------------------------------
  

    const renderTextAreaFull = (fieldName, placeholder, formData = '',  rowSpan = 2, backgroundColor = 'white',) => (
        <InputTextarea
            placeholder={placeholder}
            name={fieldName}
            autoResize
            rows={rowSpan}
            id={fieldName}
            value={formData !== '' ? formData : formik.values[fieldName]}

            onChange={(e) => {
                console.log(e.target.value)
                // setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ 
                width: '100%', 
                boxSizing: 'border-box', 
                border: 'none', 
                outline: 'none', 
                color: '#495057', 
                display: 'flex', 
                alignItems: 'center', 
                paddingTop: '8px', 
                backgroundColor: backgroundColor 
            }}
            className='px-2'
        ></InputTextarea>
    );

    const renderInputAreaForAmount = (fieldName, formData = '') => {
        var roleId = localStorage.getItem('role_id')

        return (
            <InputNumber
                inputId="currency-us"
                className="text-center"
                inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
                inputStyle={{ textAlign: 'center' }}
                placeholder="$0.00"
                value={formData != '' ? formData : formik.values[fieldName]}
                onChange={(e) => {
                    formik.setFieldValue(fieldName, e.value)
                }
                }
                readOnly={isAdmin === 'Y' ? false : true}
                mode="currency"
                currency="USD"
                locale="en-US"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                }}
                style={{
                    width: "100%",
                    height: "24px",
                    boxSizing: "border-box",
                    border: "none",
                    textAlign: "center !important",
                    marginTop: "0px",
                    outline: 'none',
                }}
            />
        )
    };


    const renderInputArea = (fieldName, placeholder, type = 'text', formdata = '', color = 'white') => (
        <input
            type={type}
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={formdata != '' ? formdata : formik.values[fieldName]}
            onChange={(e) => { formik.setFieldValue(fieldName, e.target.value) }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission on Enter key press
                }
            }}
            style={{ width: '100%', height: '24px', boxSizing: 'border-box', border: 'none', borderRadius: '0px',  textAlign: 'center', marginTop: '0px', backgroundColor: color }}
            onFocus={(e) => {
                e.target.style.setProperty('background-color', color, 'important');
            }}
            onBlur={(e) => {
                e.target.style.setProperty('background-color', color, 'important');
            }}
            autoComplete="off"
        />
    );

    const renderSelect1 = (fieldName, formData = '') => {
        // console.log('formData', formData);
        var val = (formData != '') ? formData : formik.values[fieldName];
        console.log('val', val);

        return <select
            name={fieldName}
            id={fieldName}
            value={(formData != '') ? formData : formik.values[fieldName]}
            className={'select-text-color-' + val}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', textAlign: 'center',  color: 'white', backgroundColor: '#ff0000', border: 'none' }}>
            <option value="N">No</option>
            <option value="Y">Yes</option>
        </select>
    };

    const totalClientEmailWeek = (filedName) => {
        var sum = 0;
        formik.values.performance.forEach((element, index) => {
            if (element[filedName]) {
                if (index == 0 || index == 1 || index == 2) { } else {
                    sum += parseFloat(element[filedName]);
                }

            }

        });

        return (
            <span>
                {sum}
            </span>
        )
    }

    const cilentPlayBookTotal = (filedName) => {
        var sum = 0;
        formik.values.performance.forEach((element, index) => {
            if (element[filedName]) {
                if (index == 0 || index == 1 || index == 2) { } else {
                    sum += parseFloat(element[filedName]);
                }

            }

        });
        var per = ((sum / dataForPer) * 100)


        return (
            <span>
                {`${per.toFixed(2)}%`}
            </span>
        )
    }

    const cilentPlayBookTotalPerColor = (filedName) => {
        var sum = 0;
        formik.values.performance.forEach((element, index) => {
            if (element[filedName]) {
                if (index == 0 || index == 1 || index == 2) { } else {
                    sum += parseFloat(element[filedName]);
                }

            }

        });

        var per = ((sum / dataForPer) * 100)
        var color = "#22A33D"
        if (per < 90) {
            color = "#FFBF00"
        }
        if (per < 80) {
            color = "red"
        }

        if (per < 70) {
            color = "red"
        }


        return (

            <ProgressBar value={per.toFixed(0)} color={color} ></ProgressBar>

        )
    }

    const refreshData = () => {
        setIsModalOpen(true);
    }

    const onYesRefressButton = () => {
        // const today = new Date();
        // const formattedDate = today.toISOString().split('T')[0];

        formik.setFieldValue("from_date", monday);
        
        // console.log('from_date', monday)

        handleDateInputChange("dateInput1", monday);
        
        // console.log(dateInput1)


        if (formik.values.projectPerfomanceID == 0) {
            var t = [];
            formik.values.performance.forEach((element) => {
                const newElement = { ...element, value: "no" }; 
                t.push(newElement);
            });

            formik.setFieldValue('performance', t);
            // Also reset local checklist state
            const initial = {};
            for(let i=0; i<10; i++) initial[i] = 'no';
            setChecklistValues(initial);
        } else {
            var url = Api.API_BASE_URL + 'pm-template/performance-points-reset-point/' + formik.values.projectPerfomanceID;
            fetch(url, {
                method: "GET",
                headers: {

                },
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                    }
                    performancePoints();
                    // window.location.reload();


                })
                .catch((error) => {
                    console.error("Error:", error);
                    performancePoints();
                    // window.location.reload();


                });
        }

        setIsModalOpen(false);
        // formik.handleSubmit();
        // window.location.reload();
    }


    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <form onSubmit={formik.handleSubmit} >
                {userData == undefined ? (<div className="flex d-flex justify-content-end top-button submitbutton " style={{ position: 'sticky', top: '47px', zIndex: 999, backgroundColor: '#f8f9fa', padding: '5px 15px', borderBottom: '1px solid #ddd', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <Button title='Save the PERFORMANCE HUDDLE' className="m-2 p-2 d-flex align-items-center customSave-button" type="submit" style={{ backgroundColor: '#4CAF50', border: 'none' }}>
                        <strong className="mr-2">Save</strong>
                        <i className="pi pi-save"></i>
                    </Button>
                </div>) 
                    : 'Y' == isAdmin ? (<div className="flex d-flex justify-content-between top-button submitbutton " style={{ position: 'sticky', top: '47px', zIndex: 999, backgroundColor: '#f8f9fa', padding: '5px 15px', borderBottom: '1px solid #ddd', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                        <button type='button' onClick={() => { navigate(-1); window.close(); }} className='customSave-button m-2 flex'>
                            <IoArrowBackSharp className='text-sm' />
                            <span>Back</span>
                        </button>
                        <div>
                            <Button title='Save the PERFORMANCE HUDDLE' className="m-2 p-2 d-flex align-items-center customSave-button" type="submit" style={{ backgroundColor: '#4CAF50', border: 'none' }}>
                                <strong className="mr-2">Save</strong>
                                <i className="pi pi-save"></i>
                            </Button>

                        </div>


                </div>)
                : (<div></div>)}
                <div className="" style={{ border: 'none', margin: 0, padding: 0, }} >

                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (

                        <div style={{ padding: '20px' }}>

                            {/* Section 1: PERFORMANCE HUDDLE */}
                            <div style={sectionContainerStyle}>
                                <div style={sectionHeaderStyle}>PERFORMANCE HUDDLE</div>
                                <div style={sectionContentStyle}>

                                <div className="table-container form-bg" style={{ overflowX: "auto", }}>

                                    <table style={{ borderCollapse: "collapse", }}>
                                        
                                        <tbody>
                                            <tr>
                                                <td style={{ ...cellStylea }} colSpan={2}>
                                                    Client Email Playbook Update sent out on Friday after the 15th & 30th of every month.  Standard Email Client Update sent out every other Friday
                                                </td>
                                            </tr>

                                            {/* <tr>
                                                <td style={{ ...cellStylea, minWidth: "125px", height: "24px", paddingTop: '10px', paddingBottom: '10px', }}>
                                                    Name: {<strong style={{ marginLeft: '65px', marginRight: '-45px' }}>{userName}</strong>}
                                                </td>

                                                <td style={{ ...cellStyle, minWidth: "250px", }}>
                                                    <div style={{ display: 'flex', width: '100%', gap: '12px' }}>

                                                        <td style={{ ...cellStyle, flex: 1, minWidth: "125px", textAlign: 'center', border: 'none' }}>
                                                            From
                                                        </td>

                                                        <td style={{ ...cellStyle, flex: 1, minWidth: "125px", textAlign: 'center', border: 'none' }}>
                                                            To
                                                        </td>
                                                        
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStylea, }}>
                                                    Date:
                                                </td>

                                                <td style={{ minWidth: "250px", }}>
                                                    <div style={{ display: 'flex', width: '100%', gap: '12px', padding: 0 }}>

                                                        <div style={{ ...cellStyleD, flex: 1, }}>
                                                            <input
                                                                type="date"
                                                                id="dateInput1"
                                                                
                                                                disabled

                                                                // value={dateInput1}
                                                                value={monday}

                                                                onChange={(e) => {
                                                                    formik.setFieldValue("from_date", e.target.value)                                                                    
                                                                    handleDateInputChange("dateInput1", e.target.value)
                                                                }}
                                                                
                                                                style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px',  textAlign: 'center', marginTop: '0px' }}
                                                            />
                                                        </div>
                                                        <div style={{ ...cellStyleD, flex: 1, }}>
                                                            <input
                                                                type="date"
                                                                id="dateInput2"

                                                                disabled
                                                                
                                                                // value={dateInput2}
                                                                value={sunday}
                                                                
                                                                onChange={(e) => handleDateInputChange("dateInput2", e.target.value)}
                                                                
                                                                style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px',  textAlign: 'center', marginTop: '0px', }}
                                                            />
                                                        </div>
                                                       
                                                    </div>
                                                </td>

                                            </tr> */}

                                            <tr>
                                                <td style={{ ...cellStylea, minWidth: "200px", height: "40px", padding: '10px' }}>
                                                    <span>Name: </span>
                                                    <strong style={{ marginLeft: '10px' }}>{userName}</strong>
                                                </td>

                                                <td style={{ ...cellStyle, minWidth: "250px", padding: '10px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '12px' }}>
                                                        <span style={{ flex: 1, textAlign: 'center' }}>From</span>
                                                        <span style={{ flex: 1, textAlign: 'center' }}>To</span>
                                                    </div>
                                                    <div style={{ display: 'flex', width: '100%', gap: '12px', marginTop: '5px' }}>
                                                        <input
                                                            type="date"
                                                            id="dateInput1"
                                                            disabled
                                                            value={monday}
                                                            
                                                            // onChange={(e) => {
                                                            //     formik.setFieldValue("from_date", e.target.value);
                                                            //     handleDateInputChange("dateInput1", e.target.value);
                                                            // }}

                                                            style={{
                                                                flex: 1, width: '100%', height: '40px', boxSizing: 'border-box',
                                                                border: 'none', textAlign: 'center', backgroundColor: '#f5f5f5', fontWeight: 'bold'
                                                            }}
                                                        />
                                                        <input
                                                            type="date"
                                                            id="dateInput2"
                                                            disabled
                                                            value={sunday}
                                                            // onChange={(e) => handleDateInputChange("dateInput2", e.target.value)}
                                                            style={{
                                                                flex: 1, width: '100%', height: '40px', boxSizing: 'border-box',
                                                                border: 'none', textAlign: 'center', backgroundColor: '#f5f5f5', fontWeight: 'bold'
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>


                                        </tbody>
                                    </table>
                                </div>

                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: '300px', }}>
                                                Quarter
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                    LT Team {new Date().getFullYear()} Rock
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                Projections & Actuals
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                Yearly/Quarterly Variance
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                Vp Construction Ops Comments Only
                                                </th>
                                                {/* <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Core Values
                                                </th> */}

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                projectionAndAcutal.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{item.Quarter}</td>

                
                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    // index == 0 ? renderInputAreaForAmount(`q1`, formik.values.q1) :
                                                                    index == 0 ? priceBodyTemplatee(item.projection) :
                                                                        index == 1 ? renderInputAreaForAmount(`q2`, formik.values.q2) :
                                                                            index == 2 ? renderInputAreaForAmount(`q3`, formik.values.q3) :
                                                                                index == 3 ? renderInputAreaForAmount(`q4`, formik.values.q4) :
                                                                                    priceBodyTemplatee(formik.values.q1 + formik.values.q2 + formik.values.q3 + formik.values.q4)

                                                                }
                                                            </td>

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{priceBodyTemplatee(item.projection)}</td>

                                                            {/* <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{priceBodyTemplatee(item.yearly)}</td> */}

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    index == 0 ? priceBodyTemplateeYearly(item.projection - formik.values.q1) : index == 1 ? priceBodyTemplateeYearly(item.projection - formik.values.q2) : index == 2 ? priceBodyTemplateeYearly(item.projection - formik.values.q3) : index == 3 ? priceBodyTemplateeYearly(item.projection - formik.values.q4) : priceBodyTemplateeYearly(item.projection - (formik.values.q1 + formik.values.q2 + formik.values.q3 + formik.values.q4))

                                                                }
                                                            </td>

                                                            {/* <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{item.vpComments}</td> */}

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    index == 0 ? renderTextAreaFull(`vpCommentsq1`, '', formik.values.vpCommentsq1) :
                                                                        index == 1 ? renderTextAreaFull(`vpCommentsq2`, '', formik.values.vpCommentsq2) :
                                                                            index == 2 ? renderTextAreaFull(`vpCommentsq3`, '', formik.values.vpCommentsq3) :
                                                                                index == 3 ? renderTextAreaFull(`vpCommentsq4`, '', formik.values.vpCommentsq4) :
                                                                                    (<div className='p-4'></div>)
                                                                }
                                                            </td>

                                                            {/* <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH} className='px-2'>
                                                                {
                                                                    index == 0 ? renderTextAreaFull(`coreValuesq1`, '', formik.values.coreValuesq1,'',"") :
                                                                        index == 1 ? renderTextAreaFull(`coreValuesq2`, '', formik.values.coreValuesq2,'',"") :
                                                                            index == 2 ? renderTextAreaFull(`coreValuesq3`, '', formik.values.coreValuesq3,'',"") :
                                                                                index == 3 ? renderTextAreaFull(`coreValuesq4`, '', formik.values.coreValuesq4,'',"") :
                                                                                    (<div className='p-4'></div>)
                                                                }
                                                            </td> */}

                                                            
                                                        </tr>
                                                    )
                                                })
                                            }

                                        </tbody>
                                    </table>
                                </div>
                                </div>
                            </div>

                            {/* Section 2: ANNUAL DELIVERABLES */}
                            <div style={sectionContainerStyle}>
                                <div style={sectionHeaderStyle}>ANNUAL DELIVERABLES</div>
                                <div style={sectionContentStyle}>

                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        
                                        <tbody>

                                            <tr>
                                                <td style={{ ...cellStylea, width: '300px' }} >
                                                    1) Schedule and Budget

                                                </td>
                                                <td style={{ ...cellStylea, minWidth: "auto", }} >
                                                    Ensure the Project team delivers the Project on Budget and Within the Scheudled time frame
                                                </td>

                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStylea }} >
                                                    2) Customer Service
                                                </td>

                                                <td style={{ ...cellStylea, }} >
                                                    Maintain clear and Constant communication with the Client to ensure a positive outcome
                                                </td>

                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStylea, }} >
                                                    3) Training and Pro. Dev.
                                                </td>

                                                <td style={{ ...cellStylea, }} >
                                                    Support Staff through Coaching, Professional Development, leading. Take the time to teach our team.
                                                </td>

                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStylea, }} >
                                                    4) Adminstration
                                                </td>

                                                <td style={{ ...cellStylea, }} >
                                                    Full use of Buildertrend and ensure that all data is entered and sent to the Project Team.
                                                </td>

                                            </tr>



                                        </tbody>
                                    </table>
                                </div>
                                {dataForPer == 115 ? (<div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "300px" }}>
                                                    Quarter
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                    NAHB Top 25% Revenue Per Pm
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                    Projections & Actuals
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                    Yearly/Quarterly Variance
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} colSpan={2}>
                                                VP Construction Ops Comments
                                                </th>


                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={cellStyle}> Q1</td>

                                                <td style={cellStyle}>  {priceBodyTemplatee(annualDeliverables.revenue.q1)} </td>

                                                <td style={cellStyle}>  {priceBodyTemplatee(annualDeliverables.actuals.q1)} </td>

                                                <td style={cellStyle}>  {priceBodyTemplatee(annualDeliverables.variance.q1)} </td>
                                               
                                                <td style={cellStyle}>  { renderTextAreaFull(`vpComOpsq1`, '', formik.values.vpComOpsq1)} </td>
                                               
                                            </tr>
                                            <tr>
                                                <td style={cellStyle}> Q2</td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.revenue.q2)}  </td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.actuals.q2)}  </td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.variance.q2)}  </td>

                                                <td style={cellStyle}>  { renderTextAreaFull(`vpComOpsq2`, '', formik.values.vpComOpsq2)} </td>


                                            </tr>
                                            <tr>
                                                <td style={cellStyle}> Q3</td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.revenue.q3)}  </td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.actuals.q3)}  </td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.variance.q3)}  </td>

                                                <td style={cellStyle}>  { renderTextAreaFull(`vpComOpsq3`, '', formik.values.vpComOpsq3)} </td>

                                                

                                            </tr>
                                            <tr>
                                                <td style={cellStyle}> Q4</td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.revenue.q4)}  </td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.actuals.q4)}  </td>

                                                <td style={cellStyle}> {priceBodyTemplatee(annualDeliverables.variance.q4)}  </td>

                                                <td style={cellStyle}>  { renderTextAreaFull(`vpComOpsq4`, '', formik.values.vpComOpsq4)} </td>


                                              

                                            </tr>
                                            <tr>
                                                <td style={headerStyle}> YEAR</td>
                                                <td style={headerStyle}>{priceBodyTemplatee(annualDeliverables.revenue.total)}  </td>
                                                <td style={headerStyle}>{priceBodyTemplatee(annualDeliverables.actuals.total)} </td>
                                                <td style={headerStyle}>{priceBodyTemplatee(annualDeliverables.variance.total)} </td>
                                                <td style={headerStyle} className='p-4' ></td>

                                            </tr>



                                        </tbody>
                                    </table>

                                </div>) : (<div></div>)}

                                </div>
                            </div>

                            {/* Section 3: PRINCIPLES OF PROJECT MANAGEMENT */}
                            <div style={sectionContainerStyle}>
                                <div style={sectionHeaderStyle}>PRINCIPLES OF PROJECT MANAGEMENT</div>
                                <div style={sectionContentStyle}>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                       
                                        <tbody>

                                            <tr>
                                                <td style={{ ...cellStylea, width: '300px' }}>1.  Project Objectives & Goals</td>
                                                <td style={{ ...cellStylea, minWidth: 'auto' }}>What do we need to acccomplish and what is the objective of the project?  SMART goals for the project	</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>2.  Budgeting</td>
                                                <td style={cellStylea}>Create a detailed budget based on clearly defined specifcations.</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>3.  Scheduling & Estimating</td>
                                                <td style={cellStylea}>Create a a detailed GANTT Chart schedule which focusses on when they will be done.	</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>4.  Define Team Responsibilities</td>
                                                <td style={cellStylea}>Clearing defining roles and responsibilites so the team is clear on their deliverables.													</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>5.  Define Milestons</td>
                                                <td style={cellStylea}>Defining and monitoring milestones.</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>6.  Managing changes to the project.</td>
                                                <td style={cellStylea}>Keep the boat afloat.  Lite on staff and new guys starting gonna be busy!	</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>7.  Accountability & Responsibility</td>
                                                <td style={cellStylea}>Hold each other accountable through consistent communication channels.</td>
                                            </tr>

                                            <tr>
                                                <td style={cellStylea}>8.  Resrospect & Measure Successs</td>
                                                <td style={cellStylea}>Conduct a job autopy to identify areas to improve, wins, and losses.	</td>
                                            </tr>


                                            <tr>
                                                <td style={cellStyle}>Check in:  How are you doing?</td>

                                                <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`checkInHowAreYouDoing`, '', formik.values.checkInHowAreYouDoing)}
                                                </td>

                                            </tr>

                                            <tr>
                                                <td style={cellStyle}>What can I do to support you?</td>
                                               
                                                <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`whatCanIdoTosupporty`, '', formik.values.whatCanIdoTosupporty)}
                                                </td>
                                            </tr>



                                        </tbody>
                                    </table>
                                </div>
                                </div>
                            </div>

                            {/* <AccordionTab header="PAYROLL" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>

                                    <div style={{ width: "100%", padding: "10px", backgroundColor: "#f5f5f5", borderRadius: "5px", fontSize: "14px", fontFamily: "Arial, sans-serif" }}>
                                    
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", backgroundColor: "#dddddd", padding: "10px", fontWeight: "bold", textAlign: "center", color: "#333", fontSize: "14px" }}>
                                        <div>Payroll Date:</div>
                                        <div>From: {billableTime.length > 0 ? billableTime[0].payPeriodStartDate : ''}</div>
                                        <div>To: {billableTime.length > 0 ? billableTime[0].payPeriodEndDate : ''}</div>
                                        <div></div>
                                    </div>

                                    
                                    <div style={{ textAlign: "center", fontWeight: "bold", padding: "10px", backgroundColor: "#e0e0e0", marginTop: "5px", fontSize: "14px" }}>
                                        Labour Billable VS Unbillable Profit/Loss
                                    </div>

                                    
                                    <div style={{ display: "grid", gridTemplateColumns: "2fr 2fr 1fr 1fr 1fr", backgroundColor: "#dddddd", fontWeight: "bold", padding: "10px", textAlign: "center", marginTop: "5px", fontSize: "14px" }}>
                                        <div>Name</div>
                                        <div>Division</div>                                        
                                        <div>Billable Rate</div>
                                        <div>Billable Time</div>
                                        <div>Unbillable Time</div>
                                    </div>
                                    
                                    <div style={{ display: "grid", gridTemplateColumns: "2fr 2fr 1fr 1fr 1fr", backgroundColor: "#fff", padding: "10px", textAlign: "center", fontSize: "14px" }}>
                                        <div>{billableTime.length > 0 ? billableTime[0].name : "N/A"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].division : "N/A"}</div>                                        
                                        <div>${billableTime.length > 0 ? billableTime[0].billableRate : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].billableTime : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].unBillableTime : "0"}</div>
                                    </div>

                                    
                                    <div style={{ textAlign: "center", fontWeight: "bold", padding: "10px", backgroundColor: "#e0e0e0", marginTop: "5px", fontSize: "14px" }}>
                                        Unbillable Profit/Loss Breakdown
                                    </div>

                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr", backgroundColor: "#dddddd", fontWeight: "bold", padding: "10px", textAlign: "center", fontSize: "14px" }}>
                                        <div>Vacation/Stat Time</div>
                                        <div>EOS Time</div>
                                        <div>Sales Time</div>
                                        <div>Sick Time</div>
                                        <div>Total Hours</div>
                                        <div>% Unbillable Time</div>
                                        <div>Loss vs Billable</div>
                                        <div>Loss vs LB</div>
                                    </div>

                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr", backgroundColor: "#fff", padding: "10px", textAlign: "center", fontSize: "14px" }}>
                                        <div>{billableTime.length > 0 ? billableTime[0].vacationStatTime : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].eosTime : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].salesTime : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].sickTime : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].totalHours : "0"}</div>
                                        <div>{billableTime.length > 0 ? billableTime[0].unBillableTime : "0"}</div>
                                        <div>$0.00</div>
                                        <div>$0.00</div>
                                    </div>

                                    
                                    <div style={{ textAlign: "center", fontWeight: "bold", padding: "10px", backgroundColor: "#e0e0e0", marginTop: "5px", fontSize: "14px" }}>
                                        VP Construction Ops Comments
                                    </div>

                                    <textarea 
                                        placeholder="Enter comments here..." 
                                        style={{
                                            width: "100%", height: "50px", padding: "10px", border: "1px solid #ccc",
                                            outline: "none", fontSize: "14px", fontFamily: "Arial, sans-serif"
                                        }}
                                    ></textarea>
                                </div>


                                </div>
                            </AccordionTab> */}

                            {/* Section 4: PERFORMANCE BONUS MEASURABLES REVIEW */}
                            <div style={sectionContainerStyle}>
                                <div style={{ ...sectionHeaderStyle, flexDirection: 'column', alignItems: 'flex-start', gap: '5px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                        <span>{roleNameTitle} — PERFORMANCE STANDARD (WEEKLY)</span>
                                        <Button 
                                            type="button" 
                                            className="p-button-text p-button-sm" 
                                            onClick={handleOpenHistory}
                                            style={{ color: '#2c3e50', padding: '0.5rem', fontWeight: '600' }}
                                        >
                                            <FaHistory style={{ marginRight: '8px' }} />
                                            Show History
                                        </Button>
                                    </div>
                                    <div style={{ fontSize: '14px', fontWeight: 'normal', color: '#555', display: 'flex', alignItems: 'center', gap: '15px' }}>
                                        <span>Week of {monday} to {sunday}</span>
                                        {holidayInfo && (
                                            <span style={{ 
                                                backgroundColor: '#fff3cd', 
                                                color: '#856404', 
                                                padding: '2px 8px', 
                                                borderRadius: '4px', 
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                border: '1px solid #ffeeba'
                                            }}>
                                                <i className="pi pi-calendar" style={{ marginRight: '5px' }}></i>
                                                {holidayInfo}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div style={sectionContentStyle}>

                                    {/* Away Status Section */}
                                    <div style={{ padding: '20px 20px 10px 20px', borderBottom: '1px solid #eee', backgroundColor: '#fff8e1' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: formik.values.is_away ? '15px' : '0' }}>
                                            <Checkbox 
                                                inputId="is_away" 
                                                name="is_away" 
                                                checked={formik.values.is_away} 
                                                onChange={handleAwayChange} 
                                            />
                                            <label htmlFor="is_away" style={{ marginLeft: '10px', fontSize: '15px', fontWeight: '600', color: '#856404', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                Was the user Away? (Holiday, Sick, etc.)
                                            </label>
                                        </div>
                                        
                                        {formik.values.is_away && (
                                            <div style={{ marginLeft: '32px', marginTop: '10px' }}>
                                                <label htmlFor="away_reason" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 'bold', color: '#666' }}>
                                                    Reason / Comments:
                                                </label>
                                                <InputTextarea 
                                                    id="away_reason" 
                                                    name="away_reason" 
                                                    value={formik.values.away_reason} 
                                                    onChange={formik.handleChange} 
                                                    rows={3} 
                                                    style={{ width: '100%', maxWidth: '100%', borderColor: '#ccc' }} 
                                                    autoResize
                                                    placeholder="Please provide details about the absence..."
                                                />
                                            </div>
                                        )}
                                    </div>

                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    
                                    <DragPerformanceTable 
                                        performanceData={formik.values.performance} 
                                        onReorder={handlePerformanceReorder}
                                        formik={formik}
                                        checklistValues={checklistValues}
                                        onChecklistChange={handleChecklistChange}
                                    />

                                    {/* Weekly Score Summary & Hard Fail Rules */}
                                    <div style={{ marginTop: '20px', padding: '20px', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                                        <h4 style={{ margin: '0 0 15px 0', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>Weekly Score Summary</h4>
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '20px' }}>
                                            <div style={{ textAlign: 'center', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #eee' }}>
                                                <div style={{ fontSize: '13px', color: '#666', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Total Items</div>
                                                <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#333' }}>10</div>
                                            </div>
                                            <div style={{ textAlign: 'center', padding: '15px', backgroundColor: '#e3f2fd', borderRadius: '8px', border: '1px solid #bbdefb' }}>
                                                <div style={{ fontSize: '13px', color: '#1565c0', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>YES Count</div>
                                                <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#1976d2' }}>{yesCount}</div>
                                            </div>
                                            <div style={{ textAlign: 'center', padding: '15px', backgroundColor: '#ffebee', borderRadius: '8px', border: '1px solid #ffcdd2' }}>
                                                <div style={{ fontSize: '13px', color: '#c62828', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>NO Count</div>
                                                <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#d32f2f' }}>{noCount}</div>
                                            </div>
                                            <div style={{ textAlign: 'center', padding: '15px', backgroundColor: '#e8f5e9', borderRadius: '8px', border: '1px solid #c8e6c9' }}>
                                                <div style={{ fontSize: '13px', color: '#2e7d32', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Weekly Score</div>
                                                <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#2e7d32' }}>{weeklyScore}%</div>
                                            </div>
                                        </div>

                                        <div style={{ borderTop: '1px solid #eee', paddingTop: '15px' }}>
                                            <h4 style={{ margin: '0 0 10px 0', color: '#d32f2f', fontSize: '16px', display: 'flex', alignItems: 'center' }}>
                                                Hard Fail Rules 
                                                {(checklistValues[0] === 'no' || checklistValues[1] === 'no') && 
                                                    <span style={{ marginLeft: '10px', backgroundColor: '#d32f2f', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '12px'}}>FAIL TRIGGERED</span>
                                                }
                                            </h4>
                                            <p style={{ margin: '0 0 8px 0', fontSize: '14px', fontStyle: 'italic' }}>Regardless of percentage, the week is an automatic FAIL if the first two rows are not met:</p>
                                            <ul style={{ margin: '0 0 0 20px', padding: 0, fontSize: '14px', lineHeight: '1.6' }}>
                                                <li style={checklistValues[0] === 'no' ? {color: '#d32f2f', fontWeight: 'bold'} : {}}>
                                                    Item #1 (Priority Rule) = <strong>NO</strong> 
                                                    {checklistValues[0] === 'no' && " ❌"}
                                                </li>
                                                <li style={checklistValues[1] === 'no' ? {color: '#d32f2f', fontWeight: 'bold'} : {}}>
                                                    Item #2 (Priority Rule) = <strong>NO</strong>
                                                    {checklistValues[1] === 'no' && " ❌"}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>


                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: 'auto', textAlign: 'start' }}>
                                                    Discussion Items:
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Rows +/-
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {discussionItem.map((item, index) => (
                                                <tr>
                                                    <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`discussionItem.${index}.discussion_items`, '', formik.values.discussionItem[index].discussion_items)} </td>

                                                    <td style={cellStylea}>
                                                        
                                                        {index != 0 ? (<FaTrash onClick={() => handleDeleteInputFordiscussionItem(index)} className='delete-buttonXX' />) : null}

                                                        {discussionItem.length - 1 == index ? (<FaPlus onClick={() => handleAddInputFordiscussionItem()} className='add-buttonXX' />) : null}


                                                    </td>

                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                                </div>
                            </div>

                            {/* Section 5: GOALS FOR THE WEEK */}
                            <div style={sectionContainerStyle}>
                                <div style={sectionHeaderStyle}>GOALS FOR THE WEEK</div>
                                <div style={sectionContentStyle}>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, textAlign: 'start' }} >
                                                    Job Name
                                                </th>
                                                <th style={{ ...headerStyle, textAlign: 'start' }} >
                                                    Done
                                                </th>
                                                <th style={{ ...headerStyle, }} colSpan={2} >

                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Rows +/-
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {goalForTheWeek.map((item, key) => (
                                                <>
                                                    <tr>

                                                        {/* <td style={{ ...cellStyleW, width: "300px" }} rowSpan={2}>{renderTextAreaFull(`goalForTheWeek.${key}.title`, '', formik.values.goalForTheWeek[key].title,'red', 4)} </td> */}
                                                        <td style={{ ...cellStyleW, width: "300px" }} rowSpan={2}>{renderTextAreaFull(`goalForTheWeek.${key}.title`, '', formik.values.goalForTheWeek[key].title,4)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: '120px', height: '24px', }}>{renderSelect1(`goalForTheWeek.${key}.status`, formik.values.goalForTheWeek[key].status)} </td>
                                                        <td style={{ ...headerStyle, width: '200px',  }}>Last Week </td>
                                                        <td style={{ ...cellStyleW, minWidth: "auto" }}>{renderTextAreaFull(`goalForTheWeek.${key}.description`, '', formik.values.goalForTheWeek[key].description)} </td>


                                                        <td style={cellStylea} rowSpan={2}>

                                                            {key != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForGoalForTheWeek(key)} />) : null}

                                                            {goalForTheWeek.length - 1 == key ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForGoalForTheWeek()} />) : null}


                                                        </td>

                                                    </tr>
                                                    <tr >

                                                        <td style={{ ...dropdownCellStyle, width: '85px', height: '32px', }}>{renderSelect1(`goalForTheWeek.${key}.status_2`, formik.values.goalForTheWeek[key].status_2)} </td>
                                                        <td style={{ ...headerStyle, width: '85px', }}>This Week </td>

                                                        <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`goalForTheWeek.${key}.description_2`, '', formik.values.goalForTheWeek[key].description_2)} </td>

                                                    </tr>
                                                    <tr style={{ height: '10px' }}>

                                                    </tr>
                                                </>


                                            ))}

                                        </tbody>
                                    </table>

                                    <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, }} colSpan={2}>
                                                    TO DISCUSS (I.E. CUSTOMER ISSUES, CREW ISSUES, CUSTOMER CLOSING, ETC.)
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Rows +/-
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {toDiscuss.map((item, key) => (
                                                <tr key={key}>
                                                    {/* {console.log("toDiscuss:", toDiscuss)} */}
                                                    {/* {console.log("key:", key)} */}

                                                    <td style={{ ...cellStyleW, width: '300px' }}>{renderTextAreaFull(`toDiscuss.${key}.title`, item.title)} </td>
                                                    <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`toDiscuss.${key}.description`, item.description)} </td>

                                                    <td style={cellStylea}>

                                                        {key != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputFortoDiscuss(key)} />) : null}

                                                        {toDiscuss.length - 1 == key ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputFortoDiscuss()} />) : null}

                                                    </td>

                                                </tr>
                                            ))}



                                        </tbody>
                                    </table>
                                </div>
                                </div>
                            </div>
                        </div>

                    )}

                </div>
            </form>

            <PerformanceHistoryModal 
                visible={isHistoryModalOpen} 
                onHide={() => setIsHistoryModalOpen(false)}
                userData={userData}
                performanceItems={getInitialPerformance(currentRoleName)}
            />

            {/* {isModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Confirmation</h5>
                            <button className="modal-closex" onClick={(e) => setIsModalOpen(false)} >
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>Are you Sure to "Reset the Points"</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={(e) => setIsModalOpen(false)}>
                                No
                            </button>

                            <button className="delete-buttonx" onClick={onYesRefressButton} >
                                Yes
                            </button>

                        </div>
                    </div>
                </div>
            )} */}

        </>
    )
}

export default PmPerformancePoints
